import { render, staticRenderFns } from "./DocumentFiles.vue?vue&type=template&id=22659448"
import script from "./DocumentFiles.vue?vue&type=script&lang=js"
export * from "./DocumentFiles.vue?vue&type=script&lang=js"
import style0 from "./DocumentFiles.vue?vue&type=style&index=0&id=22659448&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports